
<div class="modal-header">
  <h4 class="modal-title pull-left">{{actionLabel}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSalvar()" (keydown.enter)="$event.preventDefault()">
    <div class="form-body row" *ngIf="type == 'participant'">
      <div class="col-md-12 m-b">
        <label class="col-sm-12 pb-1">Participantes <sup class="text-danger">*</sup></label>
        <ng-select id="id" class="ng-select-alternative" [items]="filters?.personList" 
          bindLabel="label" bindValue="id" placeholder="Selecione um participante" formControlName="user_cpf">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('user_cpf')" [erros]="fieldErros('user_cpf')"></app-field-message>
      </div>
    </div>
    <div class="form-body row" *ngIf="type == 'participantForeign'">
      <div class="col-md-12 m-b">
        <label class="col-12 pb-1">Nome <sup class="text-danger">*</sup></label>
        <input class="form-control" formControlName="name">
        <app-field-message [field]="fieldMessageRequired('name')" [erros]="fieldErros('name')"></app-field-message>
      </div>
      <div class="col-md-12 m-b">
        <label class="col-12 pb-1">Cargo</label>
        <input class="form-control" formControlName="role_txt">
        <app-field-message [field]="fieldMessageRequired('role_txt')" [erros]="fieldErros('role_txt')"></app-field-message>
      </div>
      <div class="col-md-12 m-b">
        <label class="col-sm-12 pb-1">Órgão</label>
        <ng-select id="agency_id" class="ng-select-alternative" [items]="filters?.agency" 
          bindLabel="label" bindValue="id" placeholder="Todos" formControlName="agency_id">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
      </div>
      <div class="col-md-12 m-b">
        <label class="col-12 pb-1">Telefone</label>
        <input class="form-control" formControlName="fone" (input)="maskPhone($event)" placeholder="(XX) XXXXX-XXXX">
        <app-field-message [field]="fieldMessageRequired('fone')" [erros]="fieldErros('fone')"></app-field-message>
      </div>
      <div class="col-md-12 m-b">
        <label class="col-12 pb-1">E-mail <sup class="text-danger">*</sup></label>
        <input class="form-control" formControlName="email">
        <app-field-message [field]="fieldMessageRequired('email')" [erros]="fieldErros('email')"></app-field-message>
      </div>
  </div>
  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xs" type="button" (click)="onExcluir()" *ngIf="data?.id">Excluir</button>
      <button class="btn btn-primary" type="submit">Adicionar</button>
    </div>
  </div>
</form> 
</div>
<app-loading [loader]="isLoading"></app-loading>